<template>
  <div class="popularity-ranking">
    <div class="header">
      <img src="@/assets/最高人气.png" alt />
      <div>最高人气</div>
    </div>
    <el-table
      :data="items"
      style="width: 100%"
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      cell-class-name="my-cell"
      @row-click="click"
    >
      <el-table-column label="点击量" width="200">
        <template slot-scope="scope">
          <span class="rank" v-if="scope.$index == 0">
            <img src="@/assets/第一.png" />
          </span>
          <span class="rank" v-else-if="scope.$index == 1">
            <img src="@/assets/第二.png" />
          </span>
          <span class="rank" v-else-if="scope.$index == 2">
            <img src="@/assets/第三.png" />
          </span>
          <span class="rank" v-else>{{scope.$index + 1}}</span>
          <span class="name">
            {{scope.row.name}}
            <i>{{scope.row.viewCount}}</i>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="商品" width="90">
        <template slot-scope="scope">
          <el-image
            style="width: 70px; height: 70px; border-radius: 10%"
            :src="util.getImageUrl(util.getHead(util.string2Array(scope.row.images)), '100x100')"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="place" label="产地" class="place">
        <template slot-scope="scope">
          <span class="place">{{scope.row.place}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "PopularityRanking",
  computed: {
    items() {
      return this.$store.state.product.productBase.popularityRanking;
    }
  },
  methods: {
    click(e) {
      window.open(`/product/baike/${e.id}`);
    }
  }
};
</script>

<style lang="less">
.popularity-ranking {
  .el-table__header-wrapper {
    margin-bottom: 15px;
  }

  .el-table::before {
    height: 0px;
  }

  .my-header-row {
    background: white;
  }

  .my-header-cell {
    background: #f8f8f8;
    color: #848791;
    padding: 8px 0px;
  }

  .my-header-cell:first-child {
    padding-left: 10px;
    border-radius: 28px 0 0 28px;
  }

  .my-header-cell:nth-child(2) {
    text-align: center;
  }

  .my-header-cell:nth-child(3) {
    text-align: center;
    border-radius: 0 28px 28px 0;
  }

  .my-cell {
    padding: 7px 0px;
    border: 0;
    background: white;
    cursor: pointer;
  }

  .my-cell:nth-child(3) {
    text-align: center;
  }

  .rank {
    display: inline-block;
    width: 30px;
    height: 30px;
    line-height: 20px;
    text-align: center;

    img {
      width: 20px;
      vertical-align: text-bottom;
    }
  }

  .name {
    font-size: 13px;
    color: #333;
    font-weight: 500;
    i{
      font-style: normal;
      font-size: 10px;
      color: #1b994f;
      margin-left: 5px;
      display: inline-block;
    }
  }
}
</style>

<style lang="less" scoped>
.popularity-ranking {
  width: 535px;
  display: inline-block;

  .header {
    margin: 40px 0 20px 0;
    text-align: center;
    img {
      width: 40px;
      height: 40px;

      display: inline-block;
      vertical-align: top;

      margin-right: 15px;
    }
    div {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      font-weight: bold;
      color: #333;
      vertical-align: top;
      font-family: "FZQKBYSJW";
    }
  }

  .place {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    color: #333;
    font-weight: 500;
  }
}
</style>


